import { useEffect, useState } from "react";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../../components";
import { getDenunciasPorAprobar } from "./handlers";
import { tableData } from "./tableData";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalInfraccionPorAprobar from "../../../views/modals/ModalInfraccionPorAprobar";
import Table2 from "../../../components/Table2";
import { getInfraccionConImagenes } from "../../../views/modals/ModalInfraccionPorAprobar/handlers";
import ModalInfraccionMCD from "../../../views/modals/ModalInfraccionMCD";
import ModalDatosMCD from "../../../views/modals/ModalDatosMCD/ModalDatosMCD";
import { Button } from "react-bootstrap";
import ModalMapaMCD from "../../../views/modals/ModalMapaMCD/ModalMapaMCD";


const InfraccionesNuevas = () => {
  const [infraccionesNuevas, setInfraccionesNuevas] = useState({
    data: null,
    loading: true,
    infraccion_seleccionada: null,
  });

  const { modals, handlerModal, loads } = useGeneralAppStore();

  useEffect(() => {
    const getInfraccionesNuevas = async () => {
      await getDenunciasPorAprobar(setInfraccionesNuevas, 1);
    };

    getInfraccionesNuevas();
  }, []);

  const getInfraccionCompleta = async (id) => {
    const resp = await getInfraccionConImagenes(
      // infraccionesNuevas.infraccion_seleccionada.id,
      id,
      setInfraccionesNuevas,
      // setIsLoading
    );
    if (resp) {
      // handlerModal({ modal: true, modalName: "infraccion_por_aprobar" })
      handlerModal({ modal: true, modalName: "infraccion_mcd" })
    }
  };


  return (
    <>
      <ContainerScreenGeneral linkBack={"/mcd"} titulo={"MCD - Infracciones Nuevas"} size={"lg"}>
        {infraccionesNuevas.loading ? (
          <MuniSpinner2 />
        ) : (
          infraccionesNuevas?.data?.length > 0 && (
            <div className="w-100 mx-auto mt-4" style={{ maxWidth: "750px" }}>
              <Table2
                rowsPerPageOptions={[20]}
                pageSize={20}
                height={"80vh"}
                loading={loads?.includes('detalle_denuncia')}
                data={tableData(infraccionesNuevas.data)}
                rowClick={(e) => {
                  setInfraccionesNuevas((prevState) => ({
                    ...prevState,
                    infraccion_seleccionada: e.row,
                  }));
                  getInfraccionCompleta(e.id);
                  // handlerModal({ modal: true, modalName: "infraccion_por_aprobar" });
                }}
                name="infracciones_nuevas"
              />
            </div>
          )
        )}
        <Button onClick={() => {
          handlerModal({ modal: true, modalName: 'mapa_denuncias' })
        }}>Mapa</Button>
      </ContainerScreenGeneral>
      {/* {modals.includes("infraccion_por_aprobar") && infraccionesNuevas?.infraccion_seleccionada && infraccionesNuevas?.data?.length > 0 && (
        <ModalInfraccionPorAprobar
          infraccionesNuevas={infraccionesNuevas}
          setInfraccionesNuevas={setInfraccionesNuevas}
        />
      )} */}


      {modals.includes("infraccion_mcd") && infraccionesNuevas?.infraccion_seleccionada && infraccionesNuevas?.data?.length > 0 && (
        <ModalInfraccionMCD
          infraccionesNuevas={infraccionesNuevas}
          setInfraccionesNuevas={setInfraccionesNuevas}
        />
      )}
      {modals.includes("mapa_denuncias") && (
        <ModalMapaMCD infracciones={infraccionesNuevas?.data} />
      )}


    </>
  );
};

export default InfraccionesNuevas;
